<template>
  <v-row>
    <div style="width: 70%; display: flex" class="filter">
      <svg style="position: absolute; z-index: 2; top: 32px; right: 19px" xmlns="http://www.w3.org/2000/svg" width="24"
        height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M19 6H5C3.89543 6 3 6.89543 3 8V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V8C21 6.89543 20.1046 6 19 6Z"
          stroke="#3F0E40" stroke-width="2" />
        <path
          d="M3 10C3 8.114 3 7.172 3.586 6.586C4.172 6 5.114 6 7 6H17C18.886 6 19.828 6 20.414 6.586C21 7.172 21 8.114 21 10H3Z"
          fill="#3F0E40" />
        <path d="M7 3V6M17 3V6" stroke="#3F0E40" stroke-width="2" stroke-linecap="round" />
        <path
          d="M10.5 12H7.5C7.22386 12 7 12.2239 7 12.5V13.5C7 13.7761 7.22386 14 7.5 14H10.5C10.7761 14 11 13.7761 11 13.5V12.5C11 12.2239 10.7761 12 10.5 12Z"
          fill="#3F0E40" />
        <path
          d="M10.5 16H7.5C7.22386 16 7 16.2239 7 16.5V17.5C7 17.7761 7.22386 18 7.5 18H10.5C10.7761 18 11 17.7761 11 17.5V16.5C11 16.2239 10.7761 16 10.5 16Z"
          fill="#3F0E40" />
        <path
          d="M16.5 12H13.5C13.2239 12 13 12.2239 13 12.5V13.5C13 13.7761 13.2239 14 13.5 14H16.5C16.7761 14 17 13.7761 17 13.5V12.5C17 12.2239 16.7761 12 16.5 12Z"
          fill="#3F0E40" />
        <path
          d="M16.5 16H13.5C13.2239 16 13 16.2239 13 16.5V17.5C13 17.7761 13.2239 18 13.5 18H16.5C16.7761 18 17 17.7761 17 17.5V16.5C17 16.2239 16.7761 16 16.5 16Z"
          fill="#3F0E40" />
      </svg>
      <v-col cols="12" sm="5" md="5">
        <DateRanageComponent @sendDate="handleRangeDate" :daysInputChangedTo="filterObj.dayNumber" />
      </v-col>

      <div style="margin-top: 13px" v-if="$route.name != 'requests-sources-charts'">
        <v-text-field label="الايام" v-model="filterObj.dayNumber" style="width: 80px; margin-right: 10px; height: 48px"
          outlined dense></v-text-field>
      </div>

      <v-col cols="12" sm="3" md="3" style="background: #f3f5f7; margin-top: 0px">
        <SelectInput @selectedValues="getSelectedValueAdviser" :originalItems="agentNames" label="موظف خدمه العملاء" />
      </v-col>

      <v-col cols="12" sm="2" md="2">
        <div class="d-flex justify-space-between">
          <div class="d-flex">
            <v-autocomplete :items="allStatus" style="width: 180px; padding: 2px" label="الحالة"
              v-model="filterObj.status" outlined dense>
              <template v-slot:item="{ item, attrs, on }">
                <v-list-item v-bind="attrs" v-on="on">
                  <v-list-item-title :id="attrs['aria-labelledby']" v-text="item"></v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>

            <v-btn depressed color="primary" @click="handleFilter()"
              style="height: 48px; font-size: 16px; font-weight: 700; margin-right: 20px">
              تطبيق
            </v-btn>
          </div>
          <v-btn depressed color="primary"
            style="min-width: 40px !importent; width: 45px; height: 48px; margin-right: 10px;"
            @click="exportsToExcel()">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path
                d="M20.5076 11.3992H18.5996V5.39922C18.5996 4.73922 18.0596 4.19922 17.3996 4.19922H12.5996C11.9396 4.19922 11.3996 4.73922 11.3996 5.39922V11.3992H9.49161C8.42361 11.3992 7.88361 12.6952 8.63961 13.4512L14.1476 18.9592C14.6156 19.4272 15.3716 19.4272 15.8396 18.9592L21.3476 13.4512C22.1036 12.6952 21.5756 11.3992 20.5076 11.3992ZM6.59961 23.3992C6.59961 24.0592 7.13961 24.5992 7.79961 24.5992H22.1996C22.8596 24.5992 23.3996 24.0592 23.3996 23.3992C23.3996 22.7392 22.8596 22.1992 22.1996 22.1992H7.79961C7.13961 22.1992 6.59961 22.7392 6.59961 23.3992Z"
                fill="white" />
            </svg>
          </v-btn>
        </div>
      </v-col>
    </div>
  </v-row>
</template>

<script>
import SelectInput from "@/components/Charts/SelectInput.vue";
import DateRanageComponent from "@/components/Charts/DateRangeComponent.vue";
import * as XLSX from "xlsx";
import { axiosInstance } from "@/axios/config";

export default {
  components: { SelectInput, DateRanageComponent },
  props: {
    role: {
      type: Number
    },
    page: {
      type: Number
    }
  },
  data() {
    const yesterdayDate = new Date();
    yesterdayDate.setDate(yesterdayDate.getDate() - 1); // Subtract one day

    return {
      today:
          new Date().getFullYear() +
          "-" +
          ("0" + (new Date().getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + new Date().getDate()).slice(-2),
      yesterday:
          yesterdayDate.getFullYear() +
          "-" +
          ("0" + (yesterdayDate.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + yesterdayDate.getDate()).slice(-2),
      allStatus: ["الكل", "موظف خدمة عملاء مؤرشف", "موظف خدمة عملاء قائم"],
      selectedAgents: [],
      agentNames: [],
      status: null,
      filterObj: {
        endDate: "",
        startDate: "",
        status: "",
        range: "",
        dayNumber: "",
        agentId: [],
      },
    };
  },

  watch: {
    selectedAgents(val) {
      this.filterObj.agentId = val;
    },
    "filterObj.status": function (newStatus, oldStatus) {
      switch (newStatus) {
        case "موظف خدمة عملاء قائم":
          this.status = 1;
          this.getMangersAndAgents("agent", 1);
          break;
        case "موظف خدمة عملاء مؤرشف":
          this.status = 0;
          this.getMangersAndAgents("agent", 0);
          break;
        case "الكل":
          this.status = '';
          this.getMangersAndAgents("agent");
          break;
        default:
          break;
      }
    },
    "filterObj.dayNumber": function (newDayNumber, oldDayNumber) {
      if (newDayNumber != oldDayNumber && newDayNumber > 0) {
        const currentDate = new Date();
        const new_start_date = new Date(currentDate);
        new_start_date.setDate(new_start_date.getDate() - newDayNumber + 1);
        const formattedStartDate = `${new_start_date.getFullYear()}-${(new_start_date.getMonth() + 1).
          toString().padStart(2, "0")}-${new_start_date.getDate().toString().padStart(2, "0")}`;
        this.newStartDate = formattedStartDate;
      } else {
        this.newStartDate = this.today;
      }
    },
  },

  methods: {
    handleRangeDate(val) {
      this.filterObj.startDate = val.startDate;
      this.filterObj.endDate = val.endDate;
      if (this.filterObj.dayNumber == 1) {
        this.filterObj.dayNumber = '';
      }
    },
    handleFilter() {
      this.$emit("handleFilter", this.filterObj);
    },
    exportsToExcel() {
      this.$emit("exportsToExcel");
    },
    getSelectedValueAdviser(selectedValue) {
      this.selectedAgents = selectedValue;
    },
    getMangersAndAgents(role, status = "") {
      this.agentNames = [];
      let body = new FormData();

      // Always add is_customer_service for customer service employees
      body.append("is_customer_service", 1);
      body.append("role", role);

      if (status !== "") {
        body.append("status", status);
      }
      
      axiosInstance.post(
        `/employee/admin/filterUsers`,
        body
      ).then((res) => {
        this.agentNames = res["data"]["payload"];
        this.agentNames.map((item) => {
          item["text"] = item["name"];
          item["color"] = "red";
          return item;
        });
      }).catch((error) => {
        console.error("Error fetching customer service agents:", error);
      });
    },
    setDefaultValues() {
      this.filterObj.status = (this.$route.name == "rateAverage" || this.$route.name == "productivity-charts-v3" || this.$route.name == "productivityForCustomerService" || this.$route.name == "RequestCalls" || this.$route.name == "RequestsStatus" || this.$route.name == "admin-charts" || this.$route.name == "DailyReport") ? "موظف خدمة عملاء قائم" : "الكل";
    },
  },

  created() {
    this.setDefaultValues();
    this.getMangersAndAgents("agent", 1);
  },
  mounted() {
    this.setDefaultValues();
    this.filterObj.dayNumber = 1;
    this.handleFilter();
  }
};
</script>

<style>
.filter label {
  font-size: 16px;
}

.filter .v-text-field--outlined.v-input--dense .v-label {
  font-size: 16px;
  font-weight: 700;
  color: black;
}

.filter .v-input__slot {
  height: 48px;
}

.filter .v-btn:not(.v-btn--round).v-size--default {
  min-width: 40px !important;
}

.filter .v-text-field.v-text-field--solo .v-label {
  font-size: 16px;
  font-weight: 700;
  color: black;
}

.filter .v-input:not(.file-inp) .v-input__icon {
  visibility: visible !important;
  left: 0px;
  color: black;
}

.filter .selectInput .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  background: #f3f5f7;
  margin-top: 0px;
}

.filter .selectInput .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  padding-bottom: 17px !important;
}

.filter .v-text-field.v-text-field--solo .v-label {
  top: 10px;
}
</style>
